<template>
  <div class="blade-canvas blade-switch-theme" :class="[theme]">
    <canvas></canvas>
    <slot name="full-width-container"></slot>
    <div :class="[fluid ? 'container-fluid' : 'container']">
      <div class="row">
        <div class="col-12" :class="{ 'p-0': fluid }">
          <slot> </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "blade-canvas.vue",
  props: {
    theme: String,
    fluid: {
      default: false,
      type: Boolean,
    },
  },
};
</script>

<style scoped lang="scss">
canvas {
  margin: auto;
}
canvas,
.canvas-blade {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
}

.hdr-top {
  .container-txt {
    margin-top: 23.14814815vh;
  }
}

.hdr-center {
  .container-txt {
    height: 75vh;
    margin-top: 80px;
  }
}

.canvas-txt {
  display: flex;
  flex-direction: column;
  &:not(.hdr-top) {
    justify-content: center;
  }
  p {
    font-size: 1.5625vw;
    @media screen and (min-width: map-get($grid-breakpoints, xxl)) {
      font-size: 30px;
    }
  }
}

.blade-canvas {
  height: 100vh;
  position: relative;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  &.theme-dark {
    background: #000000;
    h1,
    h2,
    p {
      color: #fff;
    }
  }
  &.theme-light {
    background: #ffffff;
    h1,
    h2,
    p {
      color: #000;
    }
  }
  h1 {
    font-size: 6.25vw;
    @media screen and (min-width: map-get($grid-breakpoints, xxl)) {
      font-size: 120px;
    }
  }

  h2 {
    font-size: 2.5vw;
    @media screen and (min-width: map-get($grid-breakpoints, xxl)) {
      font-size: 48px;
    }
  }
  .product-name h2 {
    font-size: 7.8125vw;
    @media screen and (min-width: map-get($grid-breakpoints, xxl)) {
      font-size: 150px;
    }
  }
}

.ear-container {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100vh;
  clip-path: circle(348px at calc(50% - 348px) center);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.blade-ear,
.blade-moment,
.blade-hypernova-blow-out {
  position: absolute;
}

.blade-ear {
  .canvas-headers {
    h2 {
      font-size: 6.770833333vw;
      @media screen and (min-width: map-get($grid-breakpoints, xxl)) {
        font-size: 130px;
      }
    }
  }
  h2 {
    span {
      display: block;
      line-height: 1;
    }
  }
  .canvas-copy {
    opacity: 0;
    &.txt-white .canvas-txt p {
      color: #ffffff;
    }
  }
}
.moment-container {
  overflow: hidden;
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100vh;
}
.blade-hypernova-blow-out {
  .product-stats {
    @extend .list-unstyled,
      .d-flex,
      .justify-content-between,
      .flex-column,
      .h-100;
    h2 {
      font-size: 6.25vw;
      @media screen and (min-width: map-get($grid-breakpoints, xxl)) {
        font-size: 120px;
      }
      span {
        font-family: $font-family-base;
        font-size: 2.083333333vw;
        @media screen and (min-width: map-get($grid-breakpoints, xxl)) {
          font-size: 40px;
        }
      }
    }

    p {
      font-size: 0.9375vw;
      @media screen and (min-width: map-get($grid-breakpoints, xxl)) {
        font-size: 18px;
      }
    }
    &,
    li p {
      margin: 0;
    }
    li {
      margin-top: auto;
      margin-bottom: auto;
    }
  }
}
</style>
